import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-update-button',
  templateUrl: './update-button.component.html',
  styleUrls: ['./update-button.component.scss']
})
export class UpdateButtonComponent {
  @Output() resetButton = new EventEmitter();
  @Output() updateButton = new EventEmitter();

  reset() {
    this.resetButton.emit(true);
  }

  update(): void {
    this.updateButton.emit(true);
  }

}
